import { createAction, props } from '@ngrx/store';
import { BasicInsuranceKey } from '../offer.state';
import { Franchise, MedicalOfficesSearchResult } from '../../../api';

export const changeBasicInsuranceForPerson = createAction(
  '[Offer] Change basic insurance for person',
  props<{
    personId: number;
    basicInsuranceKey: BasicInsuranceKey;
    franchise: Franchise;
    includesAccidentCoverage: boolean;
    medicalOffice?: MedicalOfficesSearchResult;
  }>(),
);

export const removeBasicInsuranceForPerson = createAction(
  '[Offer] Remove basic insurance for person',
  props<{ personId: number }>(),
);
